import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import './index.css';
import { 
  App, 
  ViewByOrganization, 
  ViewBySystem, 
  ViewByProjectMode, 
  ViewByProjectComments, 
  ViewProjectMap, 
  ViewIllustrative,
  ViewConstrained } from "./App";
import {BrowserRouter, Routes, Route} from "react-router-dom";
import ProjectSummary from './SummaryComponent/Summary.jsx'; 

const container = document.getElementById('app');
const root = createRoot(container);
root.render(
  <BrowserRouter basename="/CKC2050">
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/organization" element={<ViewByOrganization />} />
      <Route path="/system" element={<ViewBySystem />} />
      <Route path="/projectmode" element={<ViewByProjectMode />} />
      <Route path="/comments" element={<ViewByProjectComments />} />
      <Route path="/map" element={<ViewProjectMap />} />
      <Route path="/illustrative" element={<ViewIllustrative />} />
      <Route path="/constrained" element={<ViewConstrained />} />
      <Route path="/projectsummary" element={<ProjectSummary />} />
    </Routes>
  </BrowserRouter>,
);




// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
